import React from "react";
import { observer } from "mobx-react-lite";

import { AccessOrganization } from "../../services/authorization/Permissions";
import PageLayout from "../_layout/PageLayout";
import { CustomerSupportCard } from "./components/HelpCards";
import { HelpContact } from "./components/HelpContact";
import "./components/composition.scss";

export default observer(function Help() {
  return (
    <PageLayout
      titleKey="HelpPage.title"
      accessWithOneOfThePermissions={[AccessOrganization]}
    >
      <div className="help-page-container">
        <div className="help-cards-container">
          <CustomerSupportCard />
        </div>
        <div className="help-contact-container">
          <HelpContact />
        </div>
      </div>
    </PageLayout>
  );
});
